import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';
import Plyr from 'plyr';

@Component
export class BackgroundVideo extends ThemeComponent  {
    @Ref() video!: HTMLVideoElement|HTMLIFrameElement|HTMLDivElement;

    init() {

        // Ensure video exists
        if (!this.video) {
            return;
        }

        // Initialise Playr
        new Plyr(this.video);
    }
}
